// Function to fetch content from a text file
function fetchFile(filePath, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
                var fileContent = xhr.responseText;
                // Check if the content starts with '<?xml version>'
                if (fileContent.startsWith('<?xml version')) {
                    // If it starts with '<?xml version>', remove it
                    var startIndex = fileContent.indexOf('?>') + 2; // Index after '?>'
                    fileContent = fileContent.substring(startIndex).trim(); // Remove and trim
                }
                callback(fileContent);
            } else {
                console.error('Failed to fetch file: ' + filePath);
            }
        }
    };
    xhr.open('GET', filePath, true);
    xhr.send();
}
export default fetchFile;